import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function NOT() {
    const colo = useSelector((state) => state.theme)

    return (

        <div class={`${colo.theme} h-screen w-full flex flex-col justify-center items-center bg-dwam`}>
            <h1 class="text-9xl font-extrabold text-shasham tracking-widest">404</h1>
            <div class="bg-chwaram px-2 text-sm text-yakam rounded rotate-12 absolute">
                ئەم پەڕەیە بەردەست نیە
            </div>
            <button class="mt-5">
                <Link to='/home'
                    class="relative inline-block text-sm font-medium text-chwaram group active:text-penjam focus:outline-none focus:ring"
                >
                    <span
                        class="absolute inset-0 transition-transform translate-x-0.5 translate-y-0.5 bg-penjam group-hover:translate-y-0 group-hover:translate-x-0"
                    ></span>

                    <span class="relative block px-8 py-3 bg-yakam border border-current">
                        <Link to="/home">سەرەکی</Link>
                    </span>
                </Link>
            </button>
        </div>
    )
}
